export default {

}



// WEBPACK FOOTER //
// ./src/app/employee/dashboard/gadget/components/select-dates/resources/index.js